import React from 'react';

const MainPageLayout = ({ title, description, button, children, className = '' }) => {
  return (
    <div className={`w-full px-8 pb-8 pt-0 ${className}`}>
      <div className='flex items-center justify-between'>
        <div className="mt-8">
          <h2 className="!text-[24px] !font-bold !text-[#17171C]">
            {title}
          </h2>
          {description && (
            <p className="!mt-2 !text-sm !text-[#6F6F7B]">
              {description}
            </p>
          )}
        </div>
        {button}
      </div>
      <div className="mt-8">
        {children}
      </div>
    </div>
  );
};

export default MainPageLayout;